import { createAction } from "redux-actions";

export const EVENT_ACTIONS = {
    SEND_ACTION_INDEX : 'event send action index',
}

export const eventActions = {
    sendActionIndex: createAction(EVENT_ACTIONS.SEND_ACTION_INDEX, (actionIndex) => ({ actionIndex }) ),
}